import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StoreConfigService } from '@scalefast/config-angular';
import { CartProduct } from '@scalefast/core';
import { CartService, LegacyV4ConfigService } from '@scalefast/ecommerce-core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppMinicartTemplateComponent } from './minicart-template/minicart-template.component';

@Component({
  selector: 'app-minicart',
  template: `<app-minicart-template
    [cartUrl]="cartUrl"
    [cartCount]="(cartCount$ | async)!"
    [cartTotal]="(cartTotal$ | async)!"
    [products]="(products$ | async)!"
    [productsTillCartFull]="(productsTillCartFull$ | async)!"
    (removeFromCartData)="onRemoveFromCartData($event)"
    (updateCartData)="onUpdateCartData($event)"
  />`,
  standalone: true,
  imports: [AppMinicartTemplateComponent, AsyncPipe],
})
export class AppMinicartComponent implements OnInit {
  cartUrl: string;
  cartCount$: Observable<number> = EMPTY;
  cartTotal$: Observable<number> = EMPTY;
  currency$: Observable<string> = EMPTY;
  products$: Observable<CartProduct[]> = EMPTY;
  productsTillCartFull$: Observable<number> = EMPTY;
  @Input({ required: true }) cartProductRemovalConfirmed!: Observable<CartProduct>;
  @Output() showCartRemovalConfirmationModal = new EventEmitter<CartProduct>();

  constructor(
    private cartService: CartService,
    private legacyConfigService: LegacyV4ConfigService,
    private destroyRef: DestroyRef,
  ) {
    this.cartUrl = inject(StoreConfigService).getCustomRoutes()?.cart ?? 'cart';
    this.cartCount$ = this.cartService.getCount$();
    this.cartTotal$ = this.cartService.getTotal$();
    this.currency$ = this.legacyConfigService.currency$.pipe(map((curr) => curr));
    this.products$ = this.cartService.cart$.pipe(map((items) => items.products));
    this.productsTillCartFull$ = this.cartService.productsTillCartFull();
  }

  ngOnInit(): void {
    this.cartProductRemovalConfirmed.subscribe((cartProduct) => {
      this.removeCartProduct(cartProduct);
    });
  }

  onUpdateCartData(cartProduct: CartProduct): void {
    this.cartService
      .updateCart$(cartProduct)
      .pipe(
        catchError((err: any) => {
          console.log(err);
          return EMPTY;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  removeCartProduct(cartProduct: CartProduct): void {
    this.cartService
      .removeFromCart$(cartProduct)
      .pipe(
        catchError((err: any) => {
          console.log(err);
          return EMPTY;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  onRemoveFromCartData(cartProduct: CartProduct): void {
    this.showCartRemovalConfirmationModal.emit(cartProduct);
  }
}
